/**
 * twinNetworkCopy.js (iter1070) — текстовете на картите в трите нови секции
 * на началната страница, на трите езика.
 */

export const TWIN_DESC = {
  bg: {
    nutritional: "Инсулинов товар на храната, състав и честота на храненията.",
    lab: "Единен вход за резултатите — пълнота и свежест на изследванията.",
    phenotype: "Наследствени особености и как променят нуждите Ви.",
    microbiome: "Усвояване по етажи, храносмилане и чревна бариера.",
    body_comp: "Тегло, мастна и мускулна тъкан, обиколки.",
    sleep: "Часове, ритъм и възстановяване през нощта.",
    stress: "Кортизолов ритъм, напрежение и душевно състояние.",
    cardio: "Кръвно налягане, пулсов резерв и кръвни мазнини.",
    hormonal: "Шест ендокринни оси и на кой етаж е повредата.",
    metabolic_insulin: "Кръвна захар, HbA1c, инсулин и чувствителност.",
    inflammation: "hsCRP, феритин и равновесие на омега-мастните киселини.",
    movement: "Крачки, активни минути, зони на пулса и сила.",
    liver_kidney: "Чернодробни показатели и обезвреждане на веществата.",
    kidney: "Скорост на филтрация, стадий, калий и фосфор.",
    dental: "Кариес, венци, флуор и връзката с целия организъм.",
    bhi: "Тъканна среда, кратки проверки и болка по цикъл.",
    hematology: "Кръвна картина, желязо, витамин B12 и фолат.",
    neuro: "Равновесие, сетива, мислене и концентрация.",
    male_health: "Тестостерон, простата и сперматогенеза.",
    respiratory: "Задух, дихателна честота и насищане с кислород.",
  },
  en: {
    nutritional: "Insulin load of your food, composition and meal frequency.",
    lab: "A single entry point for results — completeness and freshness.",
    phenotype: "Inherited traits and how they change your needs.",
    microbiome: "Absorption floor by floor, digestion and the gut barrier.",
    body_comp: "Weight, fat and muscle tissue, circumferences.",
    sleep: "Hours, rhythm and overnight recovery.",
    stress: "Cortisol rhythm, tension and emotional state.",
    cardio: "Blood pressure, pulse reserve and blood lipids.",
    hormonal: "Six endocrine axes and which floor the fault is on.",
    metabolic_insulin: "Blood glucose, HbA1c, insulin and sensitivity.",
    inflammation: "hsCRP, ferritin and the omega fatty acid balance.",
    movement: "Steps, active minutes, heart-rate zones and strength.",
    liver_kidney: "Liver markers and the clearance of substances.",
    kidney: "Filtration rate, stage, potassium and phosphorus.",
    dental: "Caries, gums, fluoride and the link to the whole body.",
    bhi: "Tissue environment, short checks and cycle-related pain.",
    hematology: "Blood count, iron, vitamin B12 and folate.",
    neuro: "Balance, senses, thinking and concentration.",
    male_health: "Testosterone, prostate and spermatogenesis.",
    respiratory: "Breathlessness, respiratory rate and oxygen saturation.",
  },
  es: {
    nutritional: "Carga de insulina de la comida, composición y frecuencia.",
    lab: "Una sola entrada para los resultados — integridad y vigencia.",
    phenotype: "Rasgos heredados y cómo cambian sus necesidades.",
    microbiome: "Absorción piso por piso, digestión y barrera intestinal.",
    body_comp: "Peso, tejido graso y muscular, perímetros.",
    sleep: "Horas, ritmo y recuperación durante la noche.",
    stress: "Ritmo del cortisol, tensión nerviosa y estado de ánimo.",
    cardio: "Tensión arterial, reserva de pulso y lípidos en sangre.",
    hormonal: "Seis ejes endocrinos y en qué piso está la avería.",
    metabolic_insulin: "Glucosa, HbA1c, insulina y sensibilidad.",
    inflammation: "hsCRP, ferritina y equilibrio de los ácidos omega.",
    movement: "Pasos, minutos activos, zonas de pulso y fuerza.",
    liver_kidney: "Marcadores hepáticos y depuración de sustancias.",
    kidney: "Velocidad de filtración, estadio, potasio y fósforo.",
    dental: "Caries, encías, flúor y el vínculo con todo el organismo.",
    bhi: "Entorno tisular, revisiones breves y dolor según el ciclo.",
    hematology: "Hemograma, hierro, vitamina B12 y folato.",
    neuro: "Equilibrio, sentidos, pensamiento y concentración.",
    male_health: "Testosterona, próstata y espermatogénesis.",
    respiratory: "Falta de aire, frecuencia respiratoria y oxígeno.",
  },
};

export const CIRCLES = {
  bg: [
    {
      id: "stress-thyroid",
      title: "Напрежение → щитовидна жлеза → умора",
      steps: ["Продължителен кортизолов превес",
        "Потиснато превръщане на T4 в активния T3",
        "Обмяната се забавя, умората расте",
        "Умората поддържа напрежението"],
      lever: "Прекъсва се при вечерния ритъм и часовете сън, не при още едно изследване.",
    },
    {
      id: "sleep-insulin",
      title: "Кратък сън → инсулинова устойчивост → нощни събуждания",
      steps: ["Под 6,5 часа сън",
        "Чувствителността към инсулин пада още на следващия ден",
        "Кръвната захар се люлее вечер",
        "Събужданията скъсяват съня още повече"],
      lever: "Прекъсва се при състава на вечерята и часа на последното хранене.",
    },
    {
      id: "inflammation-iron",
      title: "Възпаление → желязо → кислород",
      steps: ["Повишено възпаление",
        "Хепцидинът блокира усвояването на желязото",
        "Тъканите получават по-малко кислород",
        "Недостигът на кислород усилва възпалението"],
      lever: "Прекъсва се при източника на възпалението — добавката с желязо сама не стига.",
    },
  ],
  en: [
    {
      id: "stress-thyroid",
      title: "Stress → thyroid gland → fatigue",
      steps: ["A sustained cortisol excess",
        "Suppressed conversion of T4 into active T3",
        "Metabolism slows, fatigue grows",
        "Fatigue keeps the stress going"],
      lever: "The circle breaks at your evening rhythm and hours of sleep, not at one more blood test.",
    },
    {
      id: "sleep-insulin",
      title: "Short sleep → insulin resistance → night waking",
      steps: ["Under 6.5 hours of sleep",
        "Insulin sensitivity drops the very next day",
        "Blood glucose swings in the evening",
        "The waking shortens sleep even further"],
      lever: "The circle breaks at the composition of dinner and the hour of your last meal.",
    },
    {
      id: "inflammation-iron",
      title: "Inflammation → iron → oxygen",
      steps: ["Raised inflammation",
        "Hepcidin blocks the absorption of iron",
        "Tissues receive less oxygen",
        "The oxygen shortfall drives inflammation higher"],
      lever: "The circle breaks at the source of the inflammation — an iron supplement alone is not enough.",
    },
  ],
  es: [
    {
      id: "stress-thyroid",
      title: "Tensión nerviosa → tiroides → fatiga",
      steps: ["Un exceso sostenido de cortisol",
        "Conversión frenada de T4 en T3 activa",
        "El metabolismo se ralentiza, la fatiga crece",
        "La fatiga mantiene la tensión"],
      lever: "El círculo se rompe en el ritmo de la tarde y en las horas de sueño, no en otro análisis.",
    },
    {
      id: "sleep-insulin",
      title: "Sueño corto → resistencia a la insulina → despertares",
      steps: ["Menos de 6,5 horas de sueño",
        "La sensibilidad a la insulina baja al día siguiente",
        "La glucosa oscila por la tarde",
        "Los despertares acortan aún más el sueño"],
      lever: "El círculo se rompe en la composición de la cena y en la hora de la última comida.",
    },
    {
      id: "inflammation-iron",
      title: "Inflamación → hierro → oxígeno",
      steps: ["Inflamación elevada",
        "La hepcidina bloquea la absorción del hierro",
        "Los tejidos reciben menos oxígeno",
        "La falta de oxígeno aumenta la inflamación"],
      lever: "El círculo se rompe en el origen de la inflamación — el suplemento de hierro solo no basta.",
    },
  ],
};

export const FEATURES = {
  bg: [
    { id: "chat", title: "Разговор с близнаците, включително с глас",
      text: "Питате със свои думи или с глас. Отговорът се съставя само от Вашите резултати, хранене и отбелязвания — когато данните не стигат, това се казва изрично, вместо да се предполага." },
    { id: "marker-map", title: "Карта на показателите — един собственик",
      text: "31 показателя в 10 групи. Всеки показател се оценява от точно един близнак, а останалите го ползват като контекст. Така нищо не се брои двукратно." },
    { id: "plate", title: "Симулатор на чинията",
      text: "Съставяте храненето и виждате изчисления инсулинов товар, кортизоловия отговор, отговора на кръвните мазнини и бъбречния товар от калий, фосфор и натрий." },
    { id: "today", title: "Плочка „Днес“ и цели за седмицата",
      text: "Едно кратко въвеждане на тегло, кръвно налягане, сън и настроение задвижва няколко близнака наведнъж. Всяко предложение от разговора може да се запише като цел за седмицата." },
    { id: "kegg", title: "Биологични пътища",
      text: "Приетите състояния задействат съответните биологични пътища по KEGG. Всеки път има отговорен близнак, така че активността му се вижда в оценката, а не само на картата." },
    { id: "transparency", title: "Какво влиза в тази оценка",
      text: "При всяка оценка се отваря списък с показателите, които близнакът оценява, тези, които ползва, и разделите, които са я коригирали — с причина за всяка корекция." },
  ],
  en: [
    { id: "chat", title: "Conversation with the twins, by voice too",
      text: "Ask in your own words or out loud. The answer is built only from your results, meals and entries — when the data is not enough, that is stated plainly instead of guessed." },
    { id: "marker-map", title: "Biomarker map — one owner each",
      text: "31 markers in 10 groups. Each marker is scored by exactly one twin, while the others use it as context. Nothing is counted twice." },
    { id: "plate", title: "The plate simulator",
      text: "Compose a meal and see the computed insulin load, the cortisol response, the blood lipid response and the renal load of potassium, phosphorus and sodium." },
    { id: "today", title: "The \u201eToday\u201c tile and weekly goals",
      text: "One short entry of weight, blood pressure, sleep and mood drives several twins at once. Any suggestion from the conversation can be saved as a goal for the week." },
    { id: "kegg", title: "Biological pathways",
      text: "The conditions you confirm activate the matching KEGG pathways. Every pathway has an owner twin, so its activity shows up in that twin's score and not only on the map." },
    { id: "transparency", title: "What goes into this score",
      text: "Every score opens a list of the markers the twin scores, the markers it uses, and the sections that adjusted it — with a reason for each adjustment." },
  ],
  es: [
    { id: "chat", title: "Conversación con los gemelos, también por voz",
      text: "Pregunte con sus palabras o en voz alta. La respuesta se compone solo con sus resultados, comidas y anotaciones — cuando los datos no bastan, se dice con claridad en lugar de suponerlo." },
    { id: "marker-map", title: "Mapa de marcadores — un solo responsable",
      text: "31 marcadores en 10 grupos. Cada marcador lo puntúa exactamente un gemelo y los demás lo usan como contexto. Nada se cuenta dos veces." },
    { id: "plate", title: "El simulador del plato",
      text: "Componga una comida y vea la carga de insulina calculada, la respuesta del cortisol, la respuesta de los lípidos y la carga renal de potasio, fósforo y sodio." },
    { id: "today", title: "La casilla «Hoy» y las metas de la semana",
      text: "Una anotación breve de peso, tensión arterial, sueño y ánimo mueve varios gemelos a la vez. Cualquier sugerencia de la conversación puede guardarse como meta de la semana." },
    { id: "kegg", title: "Rutas biológicas",
      text: "Las afecciones que confirma activan las rutas KEGG correspondientes. Cada ruta tiene un gemelo responsable, así que su actividad aparece en la puntuación y no solo en el mapa." },
    { id: "transparency", title: "Qué entra en esta puntuación",
      text: "Cada puntuación abre la lista de los marcadores que el gemelo puntúa, los que usa y las secciones que la han ajustado — con el motivo de cada ajuste." },
  ],
};

export const pick = (dict, lang) => dict[lang] || dict.bg;

/** Имената на близнаците на трите езика (българските идват от каталога). */
export const TWIN_LABELS = {
  en: {
    nutritional: "Nutrition",
    lab: "Laboratory tests",
    phenotype: "Heredity",
    microbiome: "Microbiome and digestion",
    body_comp: "Body composition",
    sleep: "Sleep",
    stress: "Stress and mood",
    cardio: "Heart and blood vessels",
    hormonal: "Hormones and endocrine axes",
    metabolic_insulin: "Metabolism and insulin",
    inflammation: "Inflammation",
    movement: "Movement",
    liver_kidney: "Liver",
    kidney: "Kidney health",
    dental: "Teeth and oral health",
    bhi: "Breast health",
    hematology: "Blood and haematopoiesis",
    neuro: "Nervous system and cognition",
    male_health: "Male health",
    respiratory: "Breathing and oxygen",
  },
  es: {
    nutritional: "Nutrición",
    lab: "Análisis de laboratorio",
    phenotype: "Herencia",
    microbiome: "Microbioma y digestión",
    body_comp: "Composición corporal",
    sleep: "Sueño",
    stress: "Tensión nerviosa y ánimo",
    cardio: "Corazón y vasos sanguíneos",
    hormonal: "Hormonas y ejes endocrinos",
    metabolic_insulin: "Metabolismo e insulina",
    inflammation: "Inflamación",
    movement: "Movimiento",
    liver_kidney: "Hígado",
    kidney: "Salud renal",
    dental: "Dientes y salud oral",
    bhi: "Salud mamaria",
    hematology: "Sangre y hematopoyesis",
    neuro: "Sistema nervioso y cognición",
    male_health: "Salud masculina",
    respiratory: "Respiración y oxígeno",
  },
};

/** Име на близнака за даден език, с връщане към каталога на български. */
export const twinLabel = (id, lang, fallback) =>
  (TWIN_LABELS[lang] && TWIN_LABELS[lang][id]) || fallback;
